module.exports = __webpack_public_path__ + "img/ar35_samurai01skin_shop.5633b1fc.png";